import React from "react";
import { Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Container, Grid, Profile, Page } from "tabler-react";

import { userActions } from "../../store/actions/userActions";
import { helper } from "../../utils/helpers/helper";
import SiteWrapper from "../SiteWrapper";
import AccountOverviewPage from "./AccountOverview";
import ChangePasswordPage from "./ChangePassword";
import "./style.css";

function ProfilePage(props) {
  // set an initial state
  let user = JSON.parse(localStorage.getItem("user"));
  const first_name = !!user?.first_name ? user?.first_name : "Test";
  const last_name = !!user?.last_name ? user?.last_name : "User";
  const username = first_name + " " + last_name;

  const user_type = localStorage.getItem("user_type");
  const userRole = helper.get_user_role(user_type);
  return (
    <Page>
      <Page.Main>
        <SiteWrapper>
          <div className="my-3 my-md-5">
            <Container>
              <Grid.Row>
                <Grid.Col xs={12} sm={12} md={4} lg={4} className="profileGrid">
                  <Profile
                    name={username}
                    backgroundURL="demo/photos/eberhard-grossgasteiger-311213-500.jpg"
                    avatarURL="images/avatar.png"
                    twitterURL="test"
                  >
                    <h6>{helper.capitalizeFirstLetter(userRole)}</h6>
                  </Profile>
                </Grid.Col>
                <Grid.Col lg={8}>
                  <Route
                    exact
                    path="/change-password"
                    component={ChangePasswordPage}
                  />
                  <Route
                    exact
                    path="/profile"
                    component={AccountOverviewPage}
                  />
                </Grid.Col>
              </Grid.Row>
            </Container>
          </div>
        </SiteWrapper>
      </Page.Main>
    </Page>
  );
}

function mapStateToPropsToProps(state) {
  const { user } = state.user;
  return {
    user,
  };
}
const mapDispatchToProps = {
  updateProfile: userActions.updateProfile,
};
export default connect(
  mapStateToPropsToProps,
  mapDispatchToProps
)(withRouter(ProfilePage));
